import { MaskOptionsModel } from "../masks/MaskOptionsModel";
import { TrimMask } from "../masks/TrimMask";
import { BlurMask } from "../masks/BlurMask";
import { FadeMask } from "../masks/FadeMask";
export class PaywallEngine {
    static apply(action) {
        const config = action.showWhat;
        if (!(config === null || config === void 0 ? void 0 : config.Selector))
            return;
        // verify the selector exists in the DOM before attempting to mask
        const target = document.querySelector(config.Selector);
        if (!target) {
            console.warn(`[PaywallEngine] Selector not found in DOM: "${config.Selector}"`);
            return;
        }
        const options = new MaskOptionsModel({
            Effect: config.Effect,
            TrimmingMethod: config.TrimMethod,
            Selector: config.Selector,
            AllowedCharactersCount: config.AllowedCharactersCount,
            AllowedFadedCharactersCount: config.AllowedFadedCharactersCount,
            Terminator: config.Terminator || "...",
            ContainerHeight: config.ContainerHeight,
            TemplateType: config.TemplateType,
            ExcludeClasses: config.ExcludeClasses || ['Mg2-connext']
        });
        switch (config.Effect) {
            case "blur":
                this.currentMask = new BlurMask(options);
                break;
            case "fadetrim":
            case "fade":
                this.currentMask = new FadeMask(options);
                break;
            case "trim":
            default:
                this.currentMask = new TrimMask(options);
                break;
        }
    }
    static remove() {
        if (this.currentMask) {
            this.currentMask.unMask();
            this.currentMask = null;
        }
    }
}
